'use client';
import { useRouter } from 'next/navigation';
import { SplaceMark } from '@/components/ui/Logo';
import type { WizardCtx } from '../types';
import { StepLayout, PrimaryBtn } from '../shared';
import { useAuth } from '@splace/core';

export function DoneStep({ ctx }: { ctx: WizardCtx }) {
  const router = useRouter();
  const user = useAuth(s => s.user);
  const firstName = (user?.displayName ?? ctx.data.displayName ?? '').split(' ')[0];

  return (
    <StepLayout narrow>
      <div className="ob-done">
        <div className="ob-done-mark">
          <SplaceMark size={56} />
        </div>
        <h1 className="ob-title sp-display ob-done-title">
          {firstName ? `Welcome, ${firstName}.` : "You're in."}
        </h1>
        <p className="ob-sub ob-done-sub">
          Your account is ready. Jump in — find someone interesting before they disappear.
        </p>

        {user?.displayName && (
          <div className="ob-done-summary">
            <SummaryRow label="Name" value={user.displayName} />
          </div>
        )}

        <div className="ob-row" style={{ justifyContent: 'center', marginTop: 32 }}>
          <PrimaryBtn onClick={() => router.push('/feed')}>
            Take me in
          </PrimaryBtn>
        </div>
      </div>
    </StepLayout>
  );
}

function SummaryRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="ob-summary-row">
      <span className="ob-summary-label">{label}</span>
      <span className="ob-summary-value sp-mono">{value}</span>
    </div>
  );
}
